import { sum, toChartData } from '../../util/helper';
import COUNTRIES from 'src/resources/fb-countries.json';
import LANGUAGES from 'src/resources/fb-languages.json';


export function INIT(state) {
	state.init = true;
}

export function SET_LOADING(state, isLoading) {
	state.loading = isLoading;
}

export function SET_PAGE_INSIGHTS(state, data) {
	state.stats = data;

	state.pageViewSum = sum(data.pageViewsTotal, 'value');
	state.pageViewChart = toChartData(data.pageViewsTotal, 'value', 'end_time');

	state.pageLikesSum = sum(data.pageActionsPostReactionsLikeTotal, 'value');
	state.pageLikesChart = toChartData(data.pageActionsPostReactionsLikeTotal, 'value', 'end_time');

	state.pageActionsSum = sum(data.pageTotalActions, 'value');
	state.pageActionsChart = toChartData(data.pageTotalActions, 'value', 'end_time');

	state.postEngagementSum = sum(data.pagePostEngagements, 'value');
	state.postEngagementChart = toChartData(data.pagePostEngagements, 'value', 'end_time');

	state.pageFollowsSum = sum(data.pageDailyFollows, 'value');
	state.pageFollowsChart = toChartData(data.pageDailyFollows, 'value', 'end_time');

	state.pageImpressionsSum = sum(data.pageImpressions, 'value');
	state.pageImpressionsChart = toChartData(data.pageImpressions, 'value', 'end_time');

	state.pageFansGenderAgeChart = toGenderChart(data.pageFansGenderAge);
	state.pageFansCity = toTableData(data.pageFansCity);
	state.pageFansCountry = translate(toTableData(data.pageFansCountry));
	state.pageFansLocale = translate(toTableData(data.pageFansLocale), 'lang');

	state.pageFollowsGenderAgeChart = toGenderChart(data.pageFollowsGenderAge);
	state.pageFollowsCity = toTableData(data.pageFollowsCity);
	state.pageFollowsLocale = translate(toTableData(data.pageFollowsLocale), 'lang');

	state.pageImpressionsByAgeGenderUniqueChart = toGenderChart(data.pageImpressionsByAgeGenderUnique);
	state.pageImpressionsByCityUnique = toTableData(data.pageImpressionsByCityUnique);
	state.pageImpressionsByCountryUnique = translate(toTableData(data.pageImpressionsByCountryUnique));
	state.pageImpressionsByLocaleUnique = translate(toTableData(data.pageImpressionsByLocaleUnique), 'lang');

	state.pageContentActivityByAgeGenderUniqueChart = toGenderChart(data.pageImpressionsByAgeGenderUnique);
	state.pageContentActivityByCityUnique = toTableData(data.pageImpressionsByCityUnique);
	state.pageContentActivityByCountryUnique = translate(toTableData(data.pageImpressionsByCountryUnique));
	state.pageContentActivityByLocaleUnique = translate(toTableData(data.pageImpressionsByLocaleUnique), 'lang');
}

export function UPDATE_PAGEINSIGHTS(state, data) {
	Object.assign(state, data);
}

function translate(data, type = 'countries') {
	type = type === 'countries' ? COUNTRIES : LANGUAGES;
	return data.map(el => ({ ...el, name: type[el.name] }));
}

function toTableData(data) {
	if (!data) return [];
	const obj = data[data.length - 1].value;

	const sorted = Object.fromEntries(Object.entries(obj).sort(([,a],[,b]) => b - a));

	const array = [];

	for (const [key, value] of Object.entries(sorted)) {
		array.push({ name: key, value });
	}

	return array;
}


const dataTemplate = [
	{ x: '65+', y: 0 },
	{ x: '55-64', y: 0 },
	{ x: '45-54', y: 0 },
	{ x: '35-44', y: 0 },
	{ x: '25-34', y: 0 },
	{ x: '18-24', y: 0 },
	{ x: '13-17', y: 0 },
];

function toGenderChart(data) {
	let female = dataTemplate.map(o => ({ ...o }));
	let male = dataTemplate.map(o => ({ ...o }));

	if (!data) return {};

	const arrayOfValues = data.map(obj => obj.value);

	for (let item of arrayOfValues) {
		for (const [key, value] of Object.entries(item)) {
			const gender = key.substr(0, 1);
			const age = key.slice(2);

			if (gender === 'F') {
				female.map((el) => {
					if (el.x === age) el.y += value;
				});
			}

			if (gender === 'M') {
				male.map((el) => {
					if (el.x === age) el.y += value;
				});
			}
		}
	}

	const maleTotal = male.reduce((prev, cur) => prev + cur.y, 0);
	const femaleTotal = female.reduce((prev, cur) => prev + cur.y, 0);

	female = female.map((el) => {
		el.y = Math.round((el.y /= femaleTotal) * 100);
		return el;
	});

	male = male.map((el) => {
		el.y = Math.round((el.y /= maleTotal) * 100);
		return el;
	});

	return { female, male, maleTotal, femaleTotal };
}
